import { reactive } from 'vue';

export interface ConfirmOptions {
  title: string;
  text?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

const state = reactive<{ open: boolean; options: ConfirmOptions }>({
  open: false,
  options: { title: '' },
});
let resolver: ((v: boolean) => void) | null = null;

/** Промис-подтверждение: `if (await confirm({ title, danger })) { … }`. */
export function confirm(options: ConfirmOptions | string): Promise<boolean> {
  state.options = typeof options === 'string' ? { title: options } : options;
  state.open = true;
  return new Promise((resolve) => {
    resolver = resolve;
  });
}

export function resolveConfirm(value: boolean): void {
  if (!state.open && !resolver) return;
  state.open = false;
  const r = resolver;
  resolver = null;
  if (r) r(value);
}

export function useConfirmState() {
  return state;
}
